(function () {
  function initCarousel(root) {
    var slider = root.querySelector('.cb-slider');
    if (!slider) return;

    var GAP        = parseFloat(root.dataset.gap)   || 16;
    var SPEED      = parseFloat(root.dataset.speed) || 40;
    var AUTOSCROLL = root.dataset.autoscroll !== 'false';

    var isDragging    = false;
    var moved         = false;
    var audioActive   = false;
    var startX        = 0;
    var scrollStart   = 0;
    var firstSetWidth = 0;

    var originals = Array.prototype.slice.call(slider.children);

    function measure() {
      firstSetWidth = 0;
      originals.forEach(function (node) {
        firstSetWidth += node.offsetWidth + GAP;
      });
    }
    measure();

    function appendCloneSet() {
      originals.forEach(function (node) {
        var clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-clone', 'true');
        slider.appendChild(clone);
      });
    }

    if (originals.length && firstSetWidth > 0) {
      var guard = 0;
      while (
        slider.scrollWidth < firstSetWidth + slider.clientWidth + GAP &&
        guard < 30
      ) {
        appendCloneSet();
        guard++;
      }
    }

    window.addEventListener('resize', measure);

    function playInlineVideos() {
      slider.querySelectorAll('video').forEach(function (v) {
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    }
    playInlineVideos();

    function normalize() {
      if (firstSetWidth <= 0) return;
      if (slider.scrollLeft >= firstSetWidth) {
        slider.scrollLeft -= firstSetWidth;
      } else if (slider.scrollLeft < 0) {
        slider.scrollLeft += firstSetWidth;
      }
    }

    var lastTime = null;

    function tick(now) {
      if (lastTime == null) lastTime = now;
      var dt = (now - lastTime) / 1000;
      lastTime = now;

      if (AUTOSCROLL && SPEED > 0 && !audioActive && !isDragging) {
        slider.scrollLeft += SPEED * dt;
        normalize();
      }
      requestAnimationFrame(tick);
    }

    if (AUTOSCROLL) requestAnimationFrame(tick);

    slider.addEventListener('scroll', normalize, { passive: true });

    slider.addEventListener('mousedown', function (e) {
      isDragging = true;
      moved = false;
      startX = e.pageX;
      scrollStart = slider.scrollLeft;
      slider.classList.add('is-dragging');
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      var delta = e.pageX - startX;
      if (Math.abs(delta) > 4) moved = true;
      slider.scrollLeft = scrollStart - delta;
      normalize();
    });

    window.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      slider.classList.remove('is-dragging');
    });

    slider.addEventListener('click', function (e) {
      var card = e.target.closest('.cb-card--video');
      if (!card || moved) return;

      var vid = card.querySelector('video');
      if (!vid) return;

      var willUnmute = vid.muted;

      slider.querySelectorAll('video').forEach(function (v) {
        v.muted = true;
        v.closest('.cb-card--video').classList.remove('is-playing');
      });

      if (willUnmute) {
        vid.muted = false;
        card.classList.add('is-playing');
        var p = vid.play();
        if (p && p.catch) p.catch(function () {});
      }

      audioActive = willUnmute;
    });
  }

  document.querySelectorAll('.cb-section').forEach(initCarousel);
})();
